import { DeviceTypes } from "../../config/documents/HardwareConfig";
import { PoolDeviceInterface } from "../Interfaces";
import Locale from "../../utils/Locale";
import PoolDevice from "./base";

export default class PoolDeviceButton extends PoolDevice implements PoolDeviceInterface {
    static minAutoFilterVersion = 4;
    static DeviceType = DeviceTypes.BUTTON;
    static Icon = "gesture-tap-button";
    static PickerTitle = Locale.gettext("Button");
}
